import { render, staticRenderFns } from "./TagDetailModal.vue?vue&type=template&id=0e46f00e&scoped=true"
import script from "./TagDetailModal.vue?vue&type=script&lang=js"
export * from "./TagDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e46f00e",
  null
  
)

export default component.exports